import { useState } from 'react'

// Owned by the view, not each FeatureToggleTable: in By release a card moves
// between sections when its toggles change, which remounts its table.
export function useToggleTableState() {
  const [expanded, setExpanded] = useState<ReadonlySet<string>>(() => new Set())
  // Rows put into "Specific" before any assignment exists, so the control stays
  // on Specific and the assignment lists show.
  const [specificMode, setSpecificMode] = useState<ReadonlySet<string>>(() => new Set())
  return { expanded, setExpanded, specificMode, setSpecificMode }
}
